import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a08e9b2f71a5117be7dbeaa7e5fbba11cb from "./generated-90c13526-f43f-4b3b-9aae-5e41135fb671.json";

import ad7b61a3080360293ab100fb445eef4d3b from "./generated-30d86d36-d81d-43a3-93fe-fb27a64aed09.json";

import a9ddb0c22e2d1af3782e174145b8a0cb8b from "./generated-f6dca44d-46cb-4ec4-b057-7a6e7bf7e578.json";

import aef4f3a18021cf46e66b12938c8c24bcfb from "./generated-def2648d-d459-4846-93fc-93bc3e006be1.json";

import aef81d7965a2032bf88c110a1d7ba7f24b from "./generated-d4be3fba-92f8-4d2f-a7b5-1617ff71944d.json";

import a3949c504ccfd4aaf976ad974923039ebb from "./generated-2e0fbe95-ed91-4a3c-8014-896504c91f8b.json";

import a5ba45e7525e79dd0848ee9a9b2c37b83b from "./generated-3b02d089-9543-4d6b-8212-d29f27fe6dc4.json";

import ac03dfc3fdcc608ae133c85219b898864b from "./generated-3e34df5e-d02d-4477-93fc-070c220356ef.json";

import a0edf395e7ed24e41ce5713e1e4f4ba9eb from "./generated-67cfd820-1639-4c99-897b-880a7c93f14b.json";

import a89aa2e033438e8d67831c7226a345bafb from "./generated-862a635a-07e5-4d22-b899-b9a96c745ff3.json";

import acdfdb29fe4a895d5cb931f634e18fcf6b from "./generated-2d55a7ac-7f92-487e-8a1f-e9e83e584bd4.json";

import a97ee0ab021de7d8ed9202a5fa05cb52ab from "./generated-10e7f2a8-1e94-4442-a447-7172e69208e4.json";

import a8982cb8b16b638955243ddda161c07a9b from "./generated-ba4ea8e3-8548-4683-bd45-61e9183a274d.json";

import aac9f769b66ed1aa66b09f623648ea2ceb from "./generated-9e8b490b-0c13-4598-a27f-a9ed2e971e15.json";

import a1d042492423d589cefaeed01e0792bd4b from "./generated-0f57f3a3-2935-484a-bca4-f730b54e09d5.json";

import a624a42c29409f821bc6b224484190ec0b from "./generated-cbaea508-02f4-4076-9ed8-ba4f876ea9f2.json";

import aff667bef90e8365deaf7deeaf75b7772b from "./generated-816a946c-277b-4e0c-b33a-1867a1e18853.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a08e9b2f71a5117be7dbeaa7e5fbba11cb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad7b61a3080360293ab100fb445eef4d3b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9ddb0c22e2d1af3782e174145b8a0cb8b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aef4f3a18021cf46e66b12938c8c24bcfb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aef81d7965a2032bf88c110a1d7ba7f24b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a3949c504ccfd4aaf976ad974923039ebb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a5ba45e7525e79dd0848ee9a9b2c37b83b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ac03dfc3fdcc608ae133c85219b898864b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a0edf395e7ed24e41ce5713e1e4f4ba9eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a89aa2e033438e8d67831c7226a345bafb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(acdfdb29fe4a895d5cb931f634e18fcf6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a97ee0ab021de7d8ed9202a5fa05cb52ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a0edf395e7ed24e41ce5713e1e4f4ba9eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a8982cb8b16b638955243ddda161c07a9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aac9f769b66ed1aa66b09f623648ea2ceb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a0edf395e7ed24e41ce5713e1e4f4ba9eb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a1d042492423d589cefaeed01e0792bd4b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a624a42c29409f821bc6b224484190ec0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aff667bef90e8365deaf7deeaf75b7772b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a1d042492423d589cefaeed01e0792bd4b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */